import { Nilable } from "@shared/utils";
import { DTO, IDTO } from "./dto";

export interface IClientePedidoPermisoTemplateDTO extends IDTO {
    template_id: number;
}

export class ClientePedidoPermisoTemplateDTO implements DTO {
    public templateId = 0;

    constructor(json: Nilable<IClientePedidoPermisoTemplateDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: IClientePedidoPermisoTemplateDTO): void {
        if (json.template_id != null) {
            this.templateId = json.template_id;
        }
    }

    public toJSON(): IClientePedidoPermisoTemplateDTO {
        return {
            template_id: this.templateId
        };
    }

}
